import {StyledServiceOrderWorkDeliveryDeliverWorkFormHelper} from "./styles";

export function ServiceOrderWorkDeliveryDeliverWorkFormHelper() {
  return (
    <StyledServiceOrderWorkDeliveryDeliverWorkFormHelper>
      <p className="helper-text bold">What happens next?</p>
      <p className="helper-text">
        Your payment for this service is securely held by Coachli.
      </p>
      <p className="helper-text">Once you mark this order as delivered:</p>
      <ul>
        <li>Your customer will be notified by email immediately.</li>
        <li>
          Your customer has 72 hours to approve your delivery, request a revision (one
          time), or open a dispute.
        </li>
        <li>
          If your customer takes no action, the order will be automatically marked as
          completed after 72 hours.
        </li>
        <li>You’ll receive payment once the order is completed</li>
      </ul>
    </StyledServiceOrderWorkDeliveryDeliverWorkFormHelper>
  );
}
